import type { AssignedUserDto } from '@proposify/document-service-api-client';
import { DocumentMetadataResponseDtoStatusEnum, DocumentMetadataResponseDtoTotalTypeEnum } from '@proposify/document-service-api-client';
import type { ProspectType } from 'services/repositories/interfaces/ProspectRepository';
import type { MigrationCompanyId, MigrationPersonId } from '../entities/MigrationEntities.ts';

interface BaseProspect {
  id: number | string;
  name: string;
  uid: string;
}

interface CompanyProspect extends BaseProspect {
  type: ProspectType.COMPANY;
  contact: {
    id: MigrationCompanyId;
    name: string;
    email: string;
  } | null;
}

interface ContactProspect extends BaseProspect {
  type: ProspectType.PERSON;
  contact: {
    id: MigrationPersonId;
    name: string;
    email: string;
  } | null;
}

export type DocumentProspect = CompanyProspect | ContactProspect;

export const DocumentStatus = DocumentMetadataResponseDtoStatusEnum;
export type DocumentStatus = DocumentMetadataResponseDtoStatusEnum;

export const PricingTotalType = DocumentMetadataResponseDtoTotalTypeEnum;
export type PricingTotalType = DocumentMetadataResponseDtoTotalTypeEnum;

export interface DocumentEntity {
  // @deprecated - the field id is the document id and is deprecated; Please use contentId for anything that is possible
  id: string;
  title?: string;
  price?: number;
  totalType: PricingTotalType;
  status?: DocumentMetadataResponseDtoStatusEnum;
  isLocked: boolean;
  assignedUser?: AssignedUserDto | null;
  prospect?: DocumentProspect | null;
  isDocumentBelongsToSameAccount: boolean;
  contentId: string;
  createdBy?: string;
  accountId?: string;
}
